import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from './axiosApi'; 
import authHeader from './authHeader';

export const fileUpload = createAsyncThunk("file/upload", async (payload) => {
  try {
    const response = await apiInstance.post("/upload", payload, {
      headers: authHeader(),
    });
    return response.data; 
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
});

const initialState = {
  file: null,
  isLoading: false,
  error: null,
};

const fileSlice = createSlice({
  name: 'fileSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fileUpload.fulfilled, (state, action) => {
        state.isLoading = false;
        state.file = action.payload.fileUrl || action.payload; 
      })
  },
});

export default fileSlice.reducer;
